"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatorStoreContext = exports.createCalculatorStore = void 0;
exports.useCalculatorStore = useCalculatorStore;
const react_1 = require("react");
const zustand_1 = require("zustand");
const createCalculatorStore = (calculatorData) => {
    return (0, zustand_1.createStore)(() => calculatorData);
};
exports.createCalculatorStore = createCalculatorStore;
exports.CalculatorStoreContext = (0, react_1.createContext)(undefined);
function useCalculatorStore(selector) {
    const store = (0, react_1.useContext)(exports.CalculatorStoreContext);
    if (!store) {
        throw new Error("Missing calculator store provider");
    }
    return (0, zustand_1.useStore)(store, selector);
}
